import React from 'react';
import { Content, ButtonToolbar } from 'rsuite';
import InventoryPageLayout from '../../../containers/inventory/PageLayout';
import PageHeader from '../../../components/PageHeader';
import PackageAvailabilityList from '../../../containers/inventory/PackageAvailabilityList';
import { PackageType } from '../../../constants/inventory/InventoryTypes';
import PackageAvailabilitySearch from '../../../containers/inventory/PackageAvailabilitySearch';

export default () => (
  <InventoryPageLayout>
    <PageHeader title="Packages Availability">
      <ButtonToolbar>
        <PackageAvailabilitySearch type={PackageType} />
      </ButtonToolbar>
    </PageHeader>
    <Content>
      <PackageAvailabilityList />
    </Content>
  </InventoryPageLayout>
);
